/**
 * @generated SignedSource<<3614fd0b2a4d667f9a81103919f3565e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type TranscriptCommentsPopoverDeleteThreadMutation$variables = {
  id: string;
};
export type TranscriptCommentsPopoverDeleteThreadMutation$data = {
  readonly Comment_DeleteThread: {
    readonly ok: boolean;
  } | null;
};
export type TranscriptCommentsPopoverDeleteThreadMutation = {
  response: TranscriptCommentsPopoverDeleteThreadMutation$data;
  variables: TranscriptCommentsPopoverDeleteThreadMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "threadId",
        "variableName": "id"
      }
    ],
    "concreteType": "DeleteThread",
    "kind": "LinkedField",
    "name": "Comment_DeleteThread",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TranscriptCommentsPopoverDeleteThreadMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TranscriptCommentsPopoverDeleteThreadMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "5c5d1b75b857383053e4c2c9e82911aa",
    "id": null,
    "metadata": {},
    "name": "TranscriptCommentsPopoverDeleteThreadMutation",
    "operationKind": "mutation",
    "text": "mutation TranscriptCommentsPopoverDeleteThreadMutation(\n  $id: ID!\n) {\n  Comment_DeleteThread(threadId: $id) {\n    ok\n  }\n}\n"
  }
};
})();

(node as any).hash = "8ac90e412d622d6549ea8b74899cb309";

export default node;
